import SectionContactFragment from '@/components/Sections/SectionContact/query'
import SectionFullWidthContentFragment from '@/components/Sections/SectionFullWidthContent/query'
import SectionHeroFragment from '@/components/Sections/SectionHero/query'
import SectionImageListFragment from '@/components/Sections/SectionImageList/query'
import SectionImageTextFragment from '@/components/Sections/SectionImageText/query'
import SectionListFragment from '@/components/Sections/SectionList/query'
import SectionOfficeFragment from '@/components/Sections/SectionOffice/query'
import SectionPartnersFragment from '@/components/Sections/SectionPartners/query'
import SectionPrivacyFragment from '@/components/Sections/SectionPrivacy/query'
import SectionSeparatorFragment from '@/components/Sections/SectionSeparator/query'
import SectionSliderFragment from '@/components/Sections/SectionSlider/query'
import SectionTeaserFragment from '@/components/Sections/SectionTeaser/query'
import SectionTextFragment from '@/components/Sections/SectionText/query'
import { graphql } from '@/lib/query'

export const SectionBuilderFragment = graphql(
  `
    fragment SectionBuilderFragment on SectionBuilderRecord @_unmask {
      sectionBuilder {
        ...SectionHeroFragment
        ...SectionSliderFragment
        ...SectionTeaserFragment
        ...SectionTextFragment
        ...SectionContactFragment
        ...SectionListFragment
        ...SectionPartnersFragment
        ...SectionPrivacyFragment
        ...SectionOfficeFragment
        ...SectionImageListFragment
        ...SectionImageTextFragment
        ...SectionSeparatorFragment
        ...SectionFullWidthContentFragment
      }
    }
  `,
  [
    SectionHeroFragment,
    SectionSliderFragment,
    SectionTextFragment,
    SectionTeaserFragment,
    SectionListFragment,
    SectionContactFragment,
    SectionPartnersFragment,
    SectionPrivacyFragment,
    SectionOfficeFragment,
    SectionImageListFragment,
    SectionImageTextFragment,
    SectionSeparatorFragment,
    SectionFullWidthContentFragment
  ]
)
